import CloseIconX2 from "./svg/CloseIconX2";
import React, {useEffect, useRef, useState} from "react";
import variables from "../styles/utils/_variables.module.scss";
import {useSelector} from "../hooks/useTypedSelector";
import moment from "jalali-moment";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {useActions} from "../hooks/useActions";
import DotLoading from "../components/DotLoading";
import useGuildQAForm from "../hooks/useGuildQAForm";
import Skeleton from "react-loading-skeleton";
import guildService from "../services/guild.service";
import Open from "./svg/Open";
import {useHistory} from "react-router-dom";
import SecondDose from "./svg/vaccination/SecondDose";
import FirstDose from "./svg/vaccination/FirstDose";
import NoDose from "./svg/vaccination/NoDose";
import UnknownDose from "./svg/vaccination/UnknownDose";

interface AlertMessageProps {
  onShowGuildBottomSheet: any;
  onSetShowGuildBottomSheet: any;
  setScanResultWebCam: any;
  setSuccessMessage: any;
  successMessage: any;
}

const GuildBottomSheet: React.FC<AlertMessageProps> = ({
                                                         onShowGuildBottomSheet,
                                                         onSetShowGuildBottomSheet,
                                                         setScanResultWebCam,
                                                         setSuccessMessage,
                                                         successMessage,
                                                       }) => {
  const {fetchGuildList} = useActions();
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState([]) as any;
  const [questionErrors, setQuestionErrors] = useState([]) as any;
  const closeGuildBottomSheet = (e: any) => {
    if (
      guildBottomSheetRef.current === e.target ||
      closeIcon.current === e.target
    ) {
      closeGuildBottomSheetProcess();
    }
  };

  const closeGuildBottomSheetProcess = () => {
    history.replace("/guild");
    fetchGuildList();
    onSetShowGuildBottomSheet(false);
    setScanResultWebCam("");
    return false;
  };

  const guildBottomSheetRef = useRef<HTMLDivElement>(null);
  const scrollIcon: any = useRef<HTMLDivElement>(null);
  const closeIcon: any = useRef<HTMLDivElement>(null);
  const detectWasScrolled = () => {
    scrollIcon.current.style.background = variables.colorGreyDark2;
  };

  // (() => {
  //   if (onShowGuildBottomSheet) {
  //     document.querySelector(".guild-bottom-sheet__content")?.scrollTo(0, 0);
  //   }
  // })();

  const status: any = {
    DISQUALIFIED: {
      class: "u-status-guild-red",
    },
    QUALIFIED: {
      class: "u-status-guild-green",
    },
    NONE: {
      class: "u-status-guild-grey",
    },
    CONDITIONAL_QUALIFIED: {
      class: "u-status-guild-orange",
    },
  };

  const {data, error, loading} = useSelector((state) => state.guildSingleLog);
  // console.log(data.id);
  // console.log("error" + "=>" + error);
  // console.log("data" + "=>" + data);
  // console.log("loading" + "=>" + loading);

  const [presentPerson, setPresentPerson] = useState(0);
  const [excludedPerson, setExcludedPerson] = useState([]);
  const [vaccinationDose, setVaccinationDose] = useState({
    noDose: 0,
    firstDose: 0,
    secondDose: 0,
    unknown: 0,
  });

  useEffect(() => {
    if (!loading && !error) {
      setTimeout(() => {
        setShow(true);
      }, 0);
    }
  }, [error, loading]);
  useEffect(() => {
    if (!loading && !error) {
      let person = data.employees
        ? data.employees.filter((value: any) => {
          return value.excluded === false;
        })
        : [];

      let excPerson = data.employees
        ? data.employees.filter((value: any) => {
          return value.excluded === true;
        })
        : [];

      let initialVaccinationDoses: any = {
        noDose: 0,
        firstDose: 0,
        secondDose: 0,
        unknown: 0,
      }
      let vaccinationDoses = data.employees
        && data.employees.forEach((value: any) => {
          if (value.vaccinationDoses === undefined) {
            initialVaccinationDoses = {
              'noDose':  'نامشخص',
              'firstDose': 'نامشخص',
              'secondDose': 'نامشخص',
              'unknown': 'نامشخص',
            }
            return setVaccinationDose(initialVaccinationDoses)
          }
          initialVaccinationDoses = {
            ...initialVaccinationDoses,
            'noDose': value.vaccinationDoses === 0 ? ++initialVaccinationDoses.noDose : initialVaccinationDoses.noDose,
            'firstDose': value.vaccinationDoses === 1 ? ++initialVaccinationDoses.firstDose : initialVaccinationDoses.firstDose,
            'secondDose': value.vaccinationDoses === 2 ? ++initialVaccinationDoses.secondDose : initialVaccinationDoses.secondDose,
            'unknown': value.vaccinationDoses === null ? ++initialVaccinationDoses.unknown : initialVaccinationDoses.unknown,
          }
          return setVaccinationDose(initialVaccinationDoses)
        });


      setExcludedPerson(excPerson);
      setPresentPerson(person.length);
      // setId(data.id);

      getQuestion(data.id);
    }
    // eslint-disable-next-line
  }, [loading, error]);

  // defining the initial state for the question form post
  // eslint-disable-next-line
  const [initialStateQuestionPost, setInitialStateQuestionPost] = useState({
    questionList: [],
    relatedId: null,
  }) as any;

  // console.log("initial state ....");
  // console.log(initialStateQuestionPost);
  // console.log("end initial state ....");
  const isMounted = React.useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [isQuestionsLoading, setIsQuestionsLoading] = useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  // console.log("all questions");
  // console.log(allQuestions);
  // console.log("end all questions");

  const getQuestion = async (id: any) => {
    setIsQuestionsLoading(true);
    try {
      const {data} = await guildService.questions({
        lang: "fa",
        pageNumber: 0,
        pageSize: 10,
        sort: "ASC",
        tag: "guilds",
      });

      if (isMounted.current) {
        setErrors([]);
        // setInitialStateQuestionPost(...initialStateQuestionPost, data.content);
        superSetValues({
          ...initialStateQuestionPost,
          // eslint-disable-next-line
          ["relatedId"]: id,
          // eslint-disable-next-line
          ["questionList"]: data.content.map((value: any) => {
            return value;
          }),
        });
        setAllQuestions(data.content);
        // console.log(data.content);
        // setPlaqueInfo({
        //   hasInfo: true,
        //   carHealthStatus: data.carHealthStatus === null ? "" : data.carHealthStatus,
        //   personHealthStatus: data.personHealthStatus === null ? "" : data.personHealthStatus,
        //   serviceType: data.serviceType,
        // });
      }
      // return false;
    } catch (error: any) {
      if (error.response) {
        // Request made and server responded
        if (error.response.status >= 500) {
          setQuestionErrors([{field: "", message: "خطا در دریافت اطلاعات"}]);
          return false;
        }
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setIsQuestionsLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
      });
    }
  }, [error]);

  // getting the event handlers from our custom hook
  const {onChange, values, superSetValues, onSubmit} = useGuildQAForm(
    postQAFormCallback,
    initialStateQuestionPost
  );
  // console.log("initial question list");
  // console.log(values);
  // console.log("end initial question list");

  // a submit function that will execute upon form submission
  async function postQAFormCallback() {
    // send "values" to database
    setIsLoading(true);
    guildService
      .postQAForm(values)
      .then((response) => {
        if (response.status === 201) {
          setSuccessMessage(!successMessage);
          fetchGuildList();
          onSetShowGuildBottomSheet(false);
        }
      })
      .catch((error: any) => {
        if (error.response) {
          // eslint-disable-next-line
          const {errors, message} = error.response.data;
          if (error.response.status === 500) {
            setErrors([{field: "", message: "خطا در سرور"}]);
            return false;
          }
        } else {
          setErrors([{field: "", message: "خطا در سرور"}]);
          return false;
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const [changeTransfom, setChangteTransform] = useState(true);
  const seeMoreRef = useRef<any>(null);

  const seeMoreFN = () => {
    changeTransfom
      ? (seeMoreRef.current.style.transform = "rotate(180deg)")
      : (seeMoreRef.current.style.transform = "rotate(0deg)");
    setChangteTransform(!changeTransfom);
  };

  const history = useHistory();
  return (
    <>
      <ToastContainer rtl/>

      {!error && !loading && (
        <div
          className="guild-bottom-sheet"
          style={{maxHeight: `${show ? "100%" : "0%"}`}}
          onClick={(event) => closeGuildBottomSheet(event)}
          ref={guildBottomSheetRef}
        >
          <div
            className="guild-bottom-sheet__content"
            style={{maxHeight: `${show ? "100%" : "0%"}`}}
            onScroll={detectWasScrolled}
          >
            <div className="bookmark">
              <div className="arrow-up"/>
            </div>
            <div
              className="close-icon"
              ref={closeIcon}
              onClick={closeGuildBottomSheetProcess}
            >
              <CloseIconX2 color="#B2B2B2"/>
            </div>

            {loading && null}

            <div className="guild-bottom-sheet__content__header--primary">
              <div className="scroll-icon" ref={scrollIcon}/>
              <h6>
                نتیجه بررسی واحد صنفی
                <div className="line"></div>
              </h6>
            </div>

            <div className="guild-bottom-sheet__content__header">
              <div className="guild-bottom-sheet__content__header--secondary">
                <h6>وضعیت کلی واحد صنفی</h6>
                <div>
                  <span
                    className={
                      loading
                        ? ""
                        : !data.status
                        ? ""
                        : status[data.status]
                          ? status[data.status].class
                          : ""
                    }
                  >
                    {" "}
                  </span>
                </div>
                <p>
                  {loading
                    ? ""
                    : data.category.permitted === true
                      ? "مجاز به فعالیت"
                      : "مجاز به فعالیت نیست"}
                </p>
              </div>
            </div>

            <div className="guild-bottom-sheet__content__section">
              <div className="guild-bottom-sheet__content__section--0">
                <h1>راهنما</h1>
                <div className="covid-status-help">
                  <div>
                    <div className="u-status-guild-red u-margin-bottom-small-1"/>
                    <h6 className="u-text-status-red u-font-1-2 u-fw-300">
                      مثبت
                    </h6>
                  </div>
                  <div>
                    <div className="u-status-guild-orange u-margin-bottom-small-1"/>
                    <h6 className="u-text-status-orange u-font-1-2 u-fw-300">
                      مشکوک
                    </h6>
                  </div>
                  <div>
                    <div className="u-status-guild-grey u-margin-bottom-small-1"/>
                    <h6 className="u-text-status-grey u-font-1-2 u-fw-300">
                      نامشخص
                    </h6>
                  </div>
                  <div>
                    <div className="u-status-guild-green u-margin-bottom-small-1"/>
                    <h6 className="u-text-status-green u-font-1-2 u-fw-300">
                      منفی
                    </h6>
                  </div>
                </div>
              </div>
              <div className="guild-bottom-sheet__content__section--1">
                <h1>فعالیت</h1>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <span>رسته واحد صنفی:</span>
                  <span>{loading ? "" : data.category.name}</span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <span>وضعیت فعالیت رسته صنفی:</span>
                  <span>
                    {loading
                      ? ""
                      : data.category.permitted === true
                        ? "مجاز به فعالیت"
                        : "مجاز به فعالیت نیست"}
                  </span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <p>
                    وضعیت فعالیت واحدهای صنفی بر اساس مصوبات کمیته انتظامی
                    اجتماعی مبازه با کرونا تعیین میگردد.
                  </p>
                </div>
              </div>

              <div className="guild-bottom-sheet__content__section--2">
                <h1>اطلاعات شاغلین</h1>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <span>تعداد افراد شاغل در واحد صنفی:</span>
                  <span>
                    {loading ? "" : data.employees ? data.employees.length : ""}
                  </span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <span>تعداد افراد حاضر:</span>
                  <span>{presentPerson}</span>
                </div>
                <div className="guild-bottom-sheet__content__section--2--row">
                  <p
                    className="status-holder"
                    style={{
                      height: `${changeTransfom ? "68px" : "fit-content"}`,
                      transition: `all .3s ease-in-out`,
                      backfaceVisibility: "hidden",
                    }}
                  >
                    {loading
                      ? ""
                      : data.employees
                        ? data.employees.map((value: any, index: any) => {
                          return (
                            <span
                              className={
                                value.status === ""
                                  ? ""
                                  : status[value.status]
                                  ? status[value.status].class
                                  : ""
                              }
                              key={index}
                            >
                              {" "}
                            </span>
                          );
                        })
                        : null}
                    {/*<span className="u-status-guild-green"></span>*/}
                    {/*<span className="u-status-guild-red"></span>*/}
                    {/*<span className="u-status-guild-orange"></span>*/}
                    {/*<span className="u-status-guild-green"></span>*/}
                    {/*<span className="u-status-guild-grey"></span>*/}
                    {/*<span className="u-status-guild-yellow"></span>*/}
                    {/*<span className="u-status-guild-yellow"></span>*/}
                    {/*<span className="u-status-guild-green"></span>*/}
                    {/*<span className="u-status-guild-red"></span>*/}
                    {/*<span className="u-status-guild-grey"></span>*/}
                    {/*<span className="u-status-guild-grey"></span>*/}
                    {/*<span className="u-status-guild-orange"></span>*/}
                  </p>
                  <section>
                    {(data.employees && data.employees.length > 16 && (
                      <i onClick={seeMoreFN} ref={seeMoreRef}>
                        <Open/>
                      </i>
                    )) ||
                    null}
                  </section>
                </div>

                <div className="guild-bottom-sheet__content__section--2--row">
                  {loading ? (
                    ""
                  ) : excludedPerson.length < 1 ? null : (
                    <div className="has-red">
                      <div className="line"></div>
                      <h3>
                        <span>پرسنل فرستاده شده به قرنطینه:</span>
                        <span>{excludedPerson.length}</span>
                      </h3>
                      {excludedPerson.map((val: any, index: any) => {
                        return (
                          <h2 key={index}>
                            <span
                              className={
                                val.status === ""
                                  ? ""
                                  : status[val.status]
                                  ? status[val.status].class
                                  : ""
                              }
                            >
                              {" "}
                            </span>
                            <span>تاریخ شروع قرنطینه:</span>
                            <span>
                              {moment(val.exclusionTime, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")}
                            </span>
                          </h2>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <div className="guild-bottom-sheet__content__section--2">
                <h1>وضعیت واکسیناسیون</h1>
                <div className="guild-bottom-sheet__content__section--1--row u-margin-bottom-small-0-9">
                  <span>تعداد افراد شاغل در واحد صنفی:</span>
                  <span>
                       {loading ? "" : data.employees ? data.employees.length : ""}
                    &nbsp;
                    نفر
                  </span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row u-margin-bottom-small-0-9">
                  <span className="u-font-1">
                    <span>
                      <SecondDose/>
                    </span>
                    نوبت دوم:
                  </span>
                  <span>
                    {vaccinationDose.secondDose}
                    &nbsp;

                    {typeof vaccinationDose.secondDose === 'number' && 'نفر'}

                  </span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row u-margin-bottom-small-0-9">
                  <span className="u-font-1">
                    <span>
                      <FirstDose/>
                    </span>
                    نوبت اول:
                  </span>
                  <span>
                    {vaccinationDose.firstDose}
                    &nbsp;

                    {typeof vaccinationDose.firstDose === 'number' && 'نفر'}

                  </span>
                </div>
                <div className="guild-bottom-sheet__content__section--1--row">
                  <span className="u-font-1">
                    <span>
                                     <UnknownDose/>
                    </span>
                    واکسیناسیون نشده:
                  </span>
                  <span>
                    {vaccinationDose.noDose}
                    &nbsp;
                    {typeof vaccinationDose.noDose === 'number' && 'نفر'}
                  </span>
                </div>

                <div className="guild-bottom-sheet__content__section--1--row">
                  <span className="u-font-1">
                    <span>
                      <NoDose/>
                    </span>
                    نامشخص :
                  </span>
                  <span>
                    {vaccinationDose.unknown}
                    &nbsp;
                    {typeof vaccinationDose.unknown === 'number' && 'نفر'}
                  </span>
                </div>
              </div>

              <div className="guild-bottom-sheet__content__section--3">
                <h1>اطلاعات مکانی واحد صنفی</h1>
                <div className="guild-bottom-sheet__content__section--3--top">
                  <div>
                    <span>استان:</span>
                    <span>{loading ? "" : data.province}</span>
                  </div>
                  <div>
                    <span>شهر:</span>
                    <span>{loading ? "" : data.city}</span>
                  </div>
                  <div>
                    <span>منطقه:</span>
                    <span>{loading ? "" : data.area}</span>
                  </div>
                </div>
                <div className="guild-bottom-sheet__content__section--3--middle">
                  <span>نشانی:</span>
                  <p>{loading ? "" : data.address}</p>
                </div>
                <div className="line"></div>

                <div className="guild-bottom-sheet__content__section--3--bottom">
                  <div>
                    <span>کد شناسه صنفی:</span>
                    <span>{loading ? "" : data.guildCode}</span>
                  </div>
                  <div>
                    <div>
                      <span>تاریخ صدور:</span>
                      <span>
                        {loading
                          ? ""
                          : data.issueDate
                            ? moment(data.issueDate, "YYYY/MM/DD")
                              .locale("fa")
                              .format("YYYY/MM/DD")
                            : null}
                      </span>
                    </div>
                    <div>
                      <span>تاریخ انقضا:</span>
                      <span>
                        {loading
                          ? ""
                          : data.expireDate
                            ? moment(data.expireDate, "YYYY/MM/DD")
                              .locale("fa")
                              .format("YYYY/MM/DD")
                            : null}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="guild-bottom-sheet__content__section--4">
                <h1>دستورالعمل های این واحد صنفی</h1>
                {/* <a href={loading ? "" : data.categoryCommandList[0].fileUrl} target="_blank" download>
              {loading ? "" : data.categoryCommandList[0].fileUrl}
            </a> */}
                <a href="https://dotic.ir/">https://dotic.ir/</a>
                <div className="u-width-80 u-margin-center-auto">
                  <button
                    className="btn btn--primary download"
                    onClick={(e) => {
                      e.preventDefault();
                      const url = loading
                        ? ""
                        : data.categoryCommandList[0].fileUrl;
                      window.open(`${url}`, "_blank");
                    }}
                  >
                    دانلود دستورالعمل ها
                  </button>
                </div>
              </div>

              <div className="guild-bottom-sheet__content__section--5">
                <h1>گزارش های مردمی</h1>

                <div
                  className="alert-card alert-card--sky u-width-95 u-margin-center-auto u-margin-top-small-1 u-margin-bottom-small-3">
                  <p>
                    شهروند گرامی لطفا نسبت به رعایت دستورالعمل های بهداشتی توسط
                    واحد فوق اعلام نظر بفرمایید.
                  </p>
                </div>
                {questionErrors.length ? (
                  <div className="error-box u-width-95 u-margin-center-auto">
                    {questionErrors?.map((error: any) => {
                      return (
                        <p className="error-box__content">{error.message}</p>
                      );
                    })}
                  </div>
                ) : null}
                {isQuestionsLoading && <Skeleton count={5}/>}
                {!questionErrors.length && !isQuestionsLoading && (
                  <form className="people-reports-form" onSubmit={onSubmit}>
                    {allQuestions.map((content: any, index: any) => {
                      return (
                        <React.Fragment key={content.id}>
                          <div className="people-reports-form__row u-margin-top-small-2">
                            <p className="people-reports-form__row__ask u-margin-bottom-small-2">
                              <span>{++index}.</span>
                              <span>{content.title}</span>
                            </p>
                            <ul
                              className="people-reports-form__row__answer"
                              onChange={(e) =>
                                onChange(
                                  e,
                                  initialStateQuestionPost,
                                  content.id
                                )
                              }
                            >
                              {content.optionList.map((list: any, ind: any) => {
                                return (
                                  <li key={list.id} data-id={++ind}>
                                    <input
                                      type="radio"
                                      name={`ask${index}`}
                                      id={list.id}
                                      value={list.id}
                                      // checked={ind === 1 ? true : false}
                                    />
                                    <label htmlFor={list.id}>
                                      {list.title}
                                    </label>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                          {index === allQuestions.length ? null : (
                            <div className="line2"></div>
                          )}
                        </React.Fragment>
                      );
                    })}
                    <button
                      className="btn btn--primary u-width-100 u-margin-top-small-2"
                      type={`${isLoading ? "button" : "submit"}`}
                      disabled={
                        !values["questionList"]
                          .map((q: any) => {
                            return q.optionList.every((item: any) => {
                              return item.selected === null;
                            });
                          })
                          .every((val: any) => val === false)
                      }
                    >
                      {!isLoading ? "ثبت نظر" : <DotLoading/>}
                    </button>
                    <div className="error-box u-margin-top-small-1">
                      {errors?.map((error: any) => {
                        return (
                          <p className="error-box__content">{error.message}</p>
                        );
                      })}
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GuildBottomSheet;
